import { createApp } from 'vue';
import App from './App.vue';
import { createPinia } from 'pinia';
import router from './router';
// Импорт Bootstrap и его стили
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

// Design tokens и общие стили
import './styles/tokens.css';
import './styles/shared/pages.css';
import './styles/shared/forms.css';
import './styles/shared/tables.css';
import './styles/shared/cards.css';
import './styles/shared/buttons.css';
import './styles/shared/modals.css';

import './axios-auth';
import { installClientErrorLogging } from './api/errorReports';

installClientErrorLogging();

const pinia = createPinia();

createApp(App).use(pinia).use(router).mount('#app');
